import React from "react";
import Container from "@material-ui/core/Container";
import Grid from "@material-ui/core/Grid";
// import Debug from "../debug/bg";
import classNames from "classnames";
import AppBar from "@material-ui/core/AppBar";
// import Typography from "@material-ui/core/Typography";

// import Bg from "../../assets/image/bg.png";
// import Bg from "../../assets/image/banner.jpg";
// import Logo from "../../assets/image/logo.png";
// import Logo from "../../assets/image/live4d-grabpay2.png";
import Logo from "../../assets/image/fatcat.png";
import Avatar from "@material-ui/core/Avatar";
import Paper from "@material-ui/core/Paper";
import classnames from "classnames";

import { makeStyles } from "@material-ui/core/styles";
import CircularProgress from "@material-ui/core/CircularProgress";

import { t2 } from "../../Locale";
import { useSelector } from "react-redux";
import { Link } from "react-router-dom";

const fontColor = "#222";

const useStyles = makeStyles({
	// ...Debug,
	paper: {
		width: "100%",
		position: "absolute",
		left: 0,
		// height: "calc(100vh - 42px)",
		overflow: "scroll",
		overflowX: "hidden",
	},
	innerPaper: {
		position: "relative",
	},
	container: {
		minHeight:
			"calc(100vh - env(safe-area-inset-bottom) - env(safe-area-inset-top))",
	},
	innerContainer: {
		minHeight:
			"calc(100vh - env(safe-area-inset-bottom) - env(safe-area-inset-top))",
	},
	// process.env.REACT_APP_ASSETS3 + "banner.jpg?d=xxxxxxx"
	appbar: {
		// backgroundImage: `url(${
		//   process.env.REACT_APP_YES_APP === undefined ? Bg : ""
		// })`,
		backgroundPosition: "center center",
		backgroundRepeat: "no-repeat",
		// backgroundSize: "100% 170px",
		// backgroundSize: "100% 100%",
		backgroundSize: "cover",

		borderBottomLeftRadius: 30,
		borderBottomRightRadius: 30,

		// height: 165,
		// minHeight: 165,
		width: "100%",
		boxShadow: "0 0 transparent",
	},
	appbarCenter: {
		alignItems: "center",
	},
	appbarLeft: {
		alignItems: "left",
		paddingTop: 24,
		color: fontColor,
	},
	logo: {
		width: 345,
		height: process.env.REACT_APP_YES_APP === undefined ? 138 : 350,
		borderRadius: 30,

		transform: "translateY(60px)",
	},
	content: {
		flexGrow: 1,
		paddingLeft: 16,
		paddingRight: 16,
	},
});

const MainContainer = ({
	children,
	render = null,
	style = {},
	loading = false,
}) => {
	const classes = useStyles();
	const language = useSelector((state) => state.Language);

	return (
		<Paper
			className={classes.paper + " " + process.env.REACT_APP_NAME}
			elevation={0}
		>
			<Container className={classes.innerPaper} elevation={0}>
				<Container
					maxWidth="sm"
					className={classes.container}
					style={{
						paddingBottom:
							process.env.REACT_APP_YES_APP === undefined ? 0 : 250,
					}}
				>
					<Grid container direction="column" className={classes.innerContainer}>
						<Grid item className={classes.debug1}>
							{render === null ? (
								<AppBar
									position="static"
									className={classnames(classes.appbar, classes.appbarCenter)}
									color="transparent"
								>
									<Link to="/">
										{process.env.REACT_APP_YES_APP === undefined ? (
											<Avatar
												alt="logo"
												src={
													process.env.REACT_APP_YES_APP === undefined
														? Logo
														: process.env.REACT_APP_ASSETS3 +
														  "logo.png?d=xxxxxxx"
												}
												variant="rounded"
												className={classes.logo}
												style={{
													height:
														process.env.REACT_APP_YES_APP === undefined
															? 138
															: 350,
												}}
											/>
										) : (
											""
										)}
									</Link>
								</AppBar>
							) : (
								<AppBar
									position="static"
									className={classnames(classes.appbar, classes.appbarLeft)}
									color="transparent"
									style={{ ...style }}
								>
									{render}
								</AppBar>
							)}
						</Grid>
						<Grid item className={classNames(classes.debug2, classes.content)}>
							{children}
						</Grid>
					</Grid>
				</Container>
			</Container>
			{loading ? (
				<div
					style={{
						position: "fixed",
						top: 0,
						left: 0,
						width: "100%",
						height: "100%",
						backgroundColor: "rgba(0, 0, 0, 0.6)",
						display: "flex",
						justifyContent: "center",
						alignItems: "center",
					}}
				>
					<div
						style={{
							justifyContent: "center",
							display: "flex",
							flexDirection: "column",
							color: "#fff",
						}}
					>
						<div style={{ textAlign: "center" }}>
							<CircularProgress />
						</div>
						<div>{t2("Please Wait", language)}</div>
					</div>
				</div>
			) : null}
		</Paper>
	);
};

export default MainContainer;
